import * as GraphqlImporter from './graphql-importer'
import commonRequestApi from '../../request'
import Response from '../../Response'
import { DocumentNode } from 'graphql'

export const SERVER_URL = '/web/gql/PlatformUserLearningScheme'

// 枚举

// 类

/**
 * 学习人数统计参数
@author: eleven
@date: 2020/4/20
 */
export class LearningUserCountParamDTO {
  /**
   * 查询的施教机构id
   */
  unitId?: string
  /**
   * 学习有效期内的期数id集合
   */
  validIssueIdList?: Array<string>
  /**
   * 考试类别ID
   */
  examTypeId?: string
  /**
   * 专业ID
   */
  professionId?: string
  /**
   * 年度
   */
  year?: number
  /**
   * 培训形态
   */
  trainingForm?: string
}

/**
 * 用户期数预约查询
@author: eleven
@date: 2020/3/13
 */
export class UserIssueReservationParamDTO {
  /**
   * 查询的用户id - 运营与参数，学员端的忽略该参数
   */
  userId?: string
}

/**
 * 用户期数校验参数
@author: eleven
@date: 2020/3/30
 */
export class UserIssueValidParam {
  /**
   * 购买的用户
   */
  userId?: string
  /**
   * 校验的期数id
   */
  issueId?: string
}

/**
 * graphql没有泛型的操作结果类
@author yeyc create 2020/3/9 15:18
 */
export class GraphqlOperateResult {
  /**
   * 返回的code
   */
  code: string
  /**
   * 返回的message
   */
  message: string
  /**
   * json字段
存放返回的参数用
   */
  expandData: Map<string, string>
}

/**
 * 每日一练
 * @author: eleven
 * @date: 2020/3/24
 */
export class DailyPracticeDTO {
  practiceId: string
  questionCount: number
}

/**
 * 易错题
@author: eleven
@date: 2020/3/24
 */
export class ErrorPronePracticeDTO {
  practiceId: string
}

/**
 * 试题练习
@author: eleven
@date: 2020/3/24
 */
export class QuestionPracticeDTO {
  practiceId: string
  fetchWay: number
  openReal: boolean
  openPractice: boolean
  openSimulation: boolean
  realRatioValue: number
  practiceRatioValue: number
  simulationRatioValue: number
}

/**
 * @author: eleven
@date: 2020/3/24
 */
export class UserCourseLearningDTO {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 选课规则ID
   */
  ruleConfigId: string
}

/**
 * @author: eleven
@date: 2020/3/24
 */
export class UserExamLearningDTO {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 场次ID
   */
  examRoundId: string
  /**
   * 试卷ID
   */
  examPaperId: string
}

/**
 * 用户期数预约信息
@author: eleven
@date: 2020/3/13
 */
export class UserIssueDTO {
  /**
   * 学习方案id
   */
  schemeId: string
  /**
   * 方案名称
   */
  scheme: string
  /**
   * 期数id
   */
  issueId: string
  /**
   * 期数标题
   */
  issueTitle: string
  /**
   * 课程学习方式
   */
  courseLearning: UserCourseLearningDTO
  /**
   * 考试学习方式
   */
  examLearning: UserExamLearningDTO
  /**
   * 练习学习方式
   */
  practiceLearning: UserPracticeLearningDTO
  /**
   * 方案封面图片地址
   */
  picture: string
  /**
   * 开始时间
   */
  startTime: string
  /**
   * 结束时间
   */
  endTime: string
  /**
   * 线下考试时间
   */
  offlineExamTime: string
  /**
   * 距离考试时间
   */
  differenceExamDay: number
  /**
   * 课程学习是否仅系统推送
   */
  systemPush: boolean
  /**
   * 期数预约创建时间
   */
  createTime: string
  /**
   * 考试类别ID
   */
  examTypeId: string
  /**
   * 专业ID
   */
  professionId: string
  /**
   * 年度
   */
  year: number
  /**
   * 培训形态
   */
  trainingForm: string
}

/**
 * @author: eleven
@date: 2020/3/24
 */
export class UserPracticeLearningDTO {
  /**
   * 学习方式
   */
  learningId: string
  /**
   * 每日一练
   */
  dailyPractice: DailyPracticeDTO
  /**
   * 易错题
   */
  errorPronePractice: ErrorPronePracticeDTO
  /**
   * 试题练习
   */
  questionPractice: QuestionPracticeDTO
}

/**
 * 用户学习时长统计
@author: eleven
@date: 2020/3/5
 */
export class UserSchemeLearningTimeDTO {
  /**
   * 学习时长 单位：s
前端自己换算成  h 或 min
   */
  learningTimeLength: number
  /**
   * 学习时长排名
   */
  learningTimeRank: number
  /**
   * 学习时长参与排名人数
   */
  totalUserCount: number
}

export class UserSchemeSimpleDTO {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 培训班名称
   */
  name: string
  /**
   * 培训班类别ID
   */
  categoryId: string
  /**
   * 考试类别id
   */
  examTypeId: string
  /**
   * 专业id
   */
  professionId: string
  /**
   * 年度
   */
  year: number
  /**
   * 培训班状态，1表示已发布、2表示配置中、3表示未发布
   */
  status: number
  /**
   * 所属地区 格式：中国/福建省/福州市
   */
  region: string
  /**
   * 培训班封面图片地址
   */
  picture: string
  /**
   * 用户ID
   */
  userId: string
  /**
   * 来源类型
   */
  sourceType: string
  /**
   * 来源ID
   */
  sourceId: string
  /**
   * 创建方式 1:系统创建 2:用户创建 3:管理员创建 4:历史迁移 5:外部接口
   */
  createType: number
  /**
   * 用户在培训班学习方案的状态，0有效，1冻结，2失效
   */
  userState: number
  /**
   * 培训结果，-1未进行考核，0考核不通过，1考核通过
   */
  trainingResult: number
  /**
   * 培训班完成时间
   */
  completedTime: string
  /**
   * 用户报名时间
   */
  registerTime: string
  /**
   * 培训班学习方案平台自定义类型ID
   */
  lSCustomerTypeId: string
}

/**
 * @author: eleven
@date: 2020/4/20
 */
export class LearningUserCountDTO {
  /**
   * 累计培训的人数
   */
  totalLearningUserCount: number
  /**
   * 正在培训的人数
   */
  validLearningUserCount: number
}

class DataGateway {
  async _commonQuery<T>(query: DocumentNode, params?: unknown, operation?: string): Promise<Response<T>> {
    return commonRequestApi<T>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 批量获取用户购买的学习方案信息
   * @param query 查询 graphql 语法文档
   * @param userIds 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getUserSchemeByUserIds(
    userIds: Array<string>,
    query: DocumentNode = GraphqlImporter.getUserSchemeByUserIds,
    operation?: string
  ): Promise<Response<Array<UserSchemeSimpleDTO>>> {
    return commonRequestApi<Array<UserSchemeSimpleDTO>>(SERVER_URL, {
      query: query,
      variables: { userIds },
      operation: operation
    })
  }

  /**   * 用户期数预约查询
   * @param paramDTO
   * @param query 查询 graphql 语法文档
   * @param paramDTO 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listUserIssueReservation(
    paramDTO: UserIssueReservationParamDTO,
    query: DocumentNode = GraphqlImporter.listUserIssueReservation,
    operation?: string
  ): Promise<Response<Array<UserIssueDTO>>> {
    return commonRequestApi<Array<UserIssueDTO>>(SERVER_URL, {
      query: query,
      variables: { paramDTO },
      operation: operation
    })
  }

  /**   * 统计累计培训的人次及学习有效期内的人数
   * @param param
   * @return LearningUserCountDTO
   * @param query 查询 graphql 语法文档
   * @param param 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async statisticTotalLearningUserCount(
    param: LearningUserCountParamDTO,
    query: DocumentNode = GraphqlImporter.statisticTotalLearningUserCount,
    operation?: string
  ): Promise<Response<LearningUserCountDTO>> {
    return commonRequestApi<LearningUserCountDTO>(SERVER_URL, {
      query: query,
      variables: { param },
      operation: operation
    })
  }

  /**   * 用户学习时长统计 - - 中间表(已实现)
   * 根据接口功能看该接口不能使用身份id
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async statisticUserSchemeLearningTime(
    query: DocumentNode = GraphqlImporter.statisticUserSchemeLearningTime,
    operation?: string
  ): Promise<Response<UserSchemeLearningTimeDTO>> {
    return commonRequestApi<UserSchemeLearningTimeDTO>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 用户期数校验
   * 200: 校验通过
   * 201:期数已过期
   * 202:期数已失效
   * 203:期数退款冻结
   * 204:期数换货冻结 - 预留code
   * 205:期数培训未开始 - 预留code
   * @param paramDto
   * @return
   * @param query 查询 graphql 语法文档
   * @param paramDto 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async validUserIssue(
    paramDto: UserIssueValidParam,
    query: DocumentNode = GraphqlImporter.validUserIssue,
    operation?: string
  ): Promise<Response<GraphqlOperateResult>> {
    return commonRequestApi<GraphqlOperateResult>(SERVER_URL, {
      query: query,
      variables: { paramDto },
      operation: operation
    })
  }
}

export default new DataGateway()
